module.exports = __webpack_public_path__ + "static/media/resales-online.c275f847.svg";